import React, { useContext, useEffect, Fragment, useState } from 'react';
import { DataGrid } from '../../../../components/DataGrid/DataGrid';
import Skeleton from '@material-ui/lab/Skeleton';
import { store as mainStore } from '../../../../store';
import { localText } from '../../../../langs/fa/data-grid';
import { store } from './Users';
import { makeStyles } from '@material-ui/core/styles';
import NoUsers from './NoUsers';
import { useHistory } from 'react-router-dom';
import { __ } from '../../../../utils/i18n';
import Switch from '@material-ui/core/Switch';
import axios from '../../../../api/axios';
import Button from '@material-ui/core/Button';
import YesNo from '../../../../components/Dialog/YesNo';
import { normalizeMobilePhone } from 'fns';

const useStyles = makeStyles((theme) => ({
  root: {
    width:'100%', height:300,
    '& .deleted span':{
      color:'red', textDecoration: 'line-through'
    }
  },
}));

const UsersList = () => {
  const classes = useStyles();
  const history = useHistory();
  const {
    showMessage,
    showError,
    state: {
      Props: { itemsCountPerPage },
    },
  } = useContext(mainStore);
  const {
    state: { users, isLoaded, search, page },
    dispatch,
    actions: { fetchingUsers },
    refresh,
  } = useContext(store);
  const columns = [
    { field: 'firstName', headerName: 'نام', flex: 1,renderCell:({value})=><span>{value.firstName}</span>,cellClassName:({value})=>value?.isDeleted?'deleted':value?.status==='pending'?'pending':'' },
    { field: 'lastName', headerName: 'نام‌خانوادگی', flex: 1,renderCell:({value})=><span>{value.lastName}</span>,cellClassName:({value})=>value?.isDeleted?'deleted':value?.status==='pending'?'pending':''  },
    { field: 'nationalCode', headerName: 'کدملی', width: 130,renderCell:({value})=><span>{value?.nationalCode || ''}</span>,cellClassName:({value})=>value?.isDeleted?'deleted':value?.status==='pending'?'pending':''  },
    { field: 'company', headerName: 'شرکت', width: 150 ,renderCell:({value})=><span>{value?.company || ''}</span>,cellClassName:({value})=>value?.isDeleted?'deleted':value?.status==='pending'?'pending':'' },
    { field: 'companyNationalCode', headerName: 'شناسه‌شرکت', width: 150,renderCell:({value})=><span>{value?.companyNationalCode || ''}</span>,cellClassName:({value})=>value?.isDeleted?'deleted':value?.status==='pending'?'pending':''  },
    { field: 'phone', headerName: 'تلفن‌شرکت', width: 130,renderCell:({value})=><span>{value?.phone || ''}</span>,cellClassName:({value})=>value?.isDeleted?'deleted':value?.status==='pending'?'pending':''  },
    { field: 'mobilePhone', headerName: 'موبایل', width: 150,renderCell:({value})=><span>{normalizeMobilePhone(value?.mobilePhone)}</span>,cellClassName:({value})=>value?.isDeleted?'deleted':value?.status==='pending'?'pending':''  },
    { field: 'role', headerName: 'نقش', width: 120,renderCell:({value})=><span>{__(value.role?.[0])}</span>,cellClassName:({value})=>value?.isDeleted?'deleted':value?.status==='pending'?'pending':''  },
    {
      field: 'status',
      headerName: 'وضعیت',
      width: 120,
      renderCell: (param) => <Switch checked={param.value} />,
    },
    {
      field: 'delete',
      headerName: 'حذف',
      width: 100,
      renderCell: ({ value }) => (
        <Button
          variant="text"
          color="primary"
          size="small"
          onClick={() => {
            if(value?.isDeleted){
              handleRestoreUser(value._id)
            }else handleShowDeleteDialog(value._id)
          }}
          style={{color:value?.isDeleted?'green':'red'}}
        >
          {value?.isDeleted?'بازگردانی':'حذف'}
        </Button>
      ),
    },
  ];
  const [userToBeDeleted, setUserToBeDeleted] = useState(null);
  const [progress, setProgress] = useState(false);

  const handlePageChange = async ({ page }) => {
    dispatch({ type: 'CHANGE_PAGE', payload: page });
  };
  const handleSelectOrder = ({ row: { id: userId, status }, field }) => {
    if (field === 'status') {
      ChangeUserStatus(userId, status);
      return;
    }
    if (field === 'delete') {
      return;
    }
    const { role } = users.docs.find((u) => u._id === userId);
    history.push(`/protected/admin/users/${[role]}/${userId}`);
  };
  const ChangeUserStatus = async (userId, status) => {
    try {
      const {
        data: { user },
      } = await axios.put(`/api/v1/admin/users/changeStatus`, {
        userId,
        status: status ? 'pending' : 'active',
      });
      dispatch({ type: 'USER', payload: user });
    } catch (error) {
      showError(error);
    }
  };
  const handleShowDeleteDialog = (userId) => {
    setUserToBeDeleted(userId);
  };
  const handleCloseDialog = async (agree) => {
    if (agree) {
      setProgress(true);
      try {
        const { data } = await axios.delete(
          `/api/v1/admin/users/${userToBeDeleted}`
        );
        if (data.ok) {
          showMessage(data.messages);
          refresh();
        }
      } catch (error) {
        showError(error);
      }
    }
    setProgress(false);
    setUserToBeDeleted(null);
  };
  const handleRestoreUser = async(userId)=>{
    try {
      const { data } = await axios.post(
        `/api/v1/admin/users/restore/${userId}`
      );
      if(data?.ok) showMessage(data?.messages);
      refresh();
    } catch (error) {
      showError(error);
    }
  }

  useEffect(() => {
    if (!page) return;
    (async () => {
      const res = await fetchingUsers(page, itemsCountPerPage, search);
      dispatch({ type: 'USERS', payload: res });
    })();
  }, [page]);

  return (
    <div className={classes.root}>
      <DataGrid
        rows={
          users && users.docs
            ? users.docs.map((u) => ({
                id: u._id,
                firstName: u,
                lastName: u,
                nationalCode: u,
                company:u,
                companyNationalCode: u,
                phone: u,
                mobilePhone: u,
                role: u,
                status: (u.status === 'active' && u?.isDeleted===false) || (u.status==='active' && !u?.isDeleted) ? true : false,
                delete: u,
              }))
            : []
        }
        columns={columns}
        localeText={localText}
        pageSize={itemsCountPerPage}
        rowCount={users && users.totalDocs ? users.totalDocs : 0}
        paginationMode="server"
        onPageChange={handlePageChange}
        loading={!isLoaded}
        disableMultipleSelection
        density="compact"
        components={{
          noRowsOverlay: NoUsers,
        }}
        onCellClick={handleSelectOrder}
        // onSelectionChange={handleSelectOrder}
      />
      <YesNo
        open={userToBeDeleted ? true : false}
        onClose={handleCloseDialog}
        title=" آیا از حذف این کاربر مطمئن هستید؟"
      />
    </div>
  );
};

export default React.memo(UsersList);
